/**
 * @description
 */
import * as postTrust from './postTrust';
import * as getTrustById from './getTrustById';
import * as putTrustById from './putTrustById';
import * as postTrustByIdDeed from './postTrustByIdDeed';

export { postTrust, getTrustById, putTrustById, postTrustByIdDeed };
